/* eslint-disable */
import { Tooltip } from "bootstrap";

// initialization of Tooltips
export default function setTooltip() {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    // Enable HTML content inside the tooltip
    return new Tooltip(tooltipTriggerEl, {
      html: true
    });
  });
}
